import {
    createContext, useCallback, useMemo, useState,
} from 'react';
import { Alert, Snackbar } from '@mui/material';
import PropTypes from 'prop-types';

export const SnackNotificationsContext = createContext(undefined);

const SnackNotificationsContextProvider = ({ children }) => {
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [label, setLabel] = useState('');
    const [severity, setSeverity] = useState(undefined);

    const setLabelAndOpen = useCallback((newLabel, newSeverity = undefined) => {
        setLabel(newLabel);
        setSeverity(newSeverity);
        setOpenSnackbar(true);
    }, []);

    const close = useCallback(() => {
        setOpenSnackbar(false);
    }, []);

    const providerObject = useMemo(() => (
        {
            visible: openSnackbar,
            open: setLabelAndOpen,
            close,
        }
    ), [openSnackbar, setLabelAndOpen, close]);

    return (
        <SnackNotificationsContext.Provider value={providerObject}>
            {children}
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                autoHideDuration={5000}
                open={openSnackbar}
                onClose={close}
                message={!severity && label}
            >
                {severity && (
                    <Alert
                        onClose={close}
                        severity={severity}
                    >
                        {label}
                    </Alert>
                )}
            </Snackbar>
        </SnackNotificationsContext.Provider>
    );
};

SnackNotificationsContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default SnackNotificationsContextProvider;
